import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { WebSocketProvider } from '@/contexts/WebSocketContext';
import { Toaster } from '@/components/ui/toaster';
import PrivateRoute from '@/components/PrivateRoute';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import WaitApprovalPage from '@/pages/WaitApprovalPage';
import CharacterRegisterPage from '@/pages/CharacterRegisterPage';
import SchedulePage from '@/pages/SchedulePage';
import AdminPage from '@/pages/AdminPage';

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <WebSocketProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/wait" element={<WaitApprovalPage />} />
            <Route
              path="/characters/update"
              element={
                <PrivateRoute>
                  <CharacterRegisterPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/schedule"
              element={
                <PrivateRoute>
                  <SchedulePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminPage />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/schedule" replace />} />
            <Route path="*" element={<Navigate to="/schedule" replace />} />
          </Routes>
          <Toaster />
          </WebSocketProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
